<template>
  <div class="SameCustomerLevelPreview">
    <el-dialog
        v-el-drag-dialog
        :visible.sync="dialogVisible"
        :close-on-click-modal="false"
        title="价格申请详情对比"
        class="customer-price"
        width="800px"
        top="10vh">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="同等级客户申请价" name="first">
          <div class="first">
            <div class="first-left">
              <div style="display: flex;flex-direction: row;margin-bottom: 5px">
                <div style="width: 70px;padding: 0 1%;font-size: 12px">特性：</div>
                <div style="width: 80%;padding: 0 1%;font-size: 12px">{{businessApplication.nameValues}}</div>
              </div>
              <div style="display: flex;flex-direction: row;margin: 1% 0">
                <div style="width: 70px;padding: 0 1%;font-size: 12px">申请价格：</div>
                <div style="width: 80%;padding: 0 1%;font-size: 12px">
                  <div v-if="businessApplication.priceApplicationType === 20">
                    <div v-if="businessApplication.floatingPriceType === 20">
                      {{"线缆单价折扣:" + businessApplication.price + "每层加工费:" + businessApplication.floatingPrice}}
                    </div>
                    <div v-else>
                      {{"线缆单价折扣:" + businessApplication.price + "加工费折扣:" + businessApplication.floatingPrice + "%"}}
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="businessApplication.standardFloatingPrice === 0">
                      {{businessApplication.price}}
                    </div>
                    <div v-else>
                      {{businessApplication.price + "/" + businessApplication.floatingPrice}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="show1" class="first-right">
              <div class="first-right-div">
                <div class="first-right-div-word">最高执行价</div>
                <div style="color: #2D8CF0;font-size: 14px">{{tableParams1.max}}</div>
              </div>
              <div class="first-right-div">
                <div v-if="businessApplication.price>=tableParams1.min && businessApplication.price<=tableParams1.max">
                  <el-progress :show-text="false" :stroke-width="20" :percentage="100" class="el-bg-inner-running"/>
                  <div :style="{left: percentage1+'%',color:color}" class="first-right-div-last">
                    <i class="el-icon-caret-top"/>
                    <div>当前申请价:<span class="number">{{businessApplication.price}}</span></div>
                  </div>
                </div>
                <div v-else-if="businessApplication.price<tableParams1.min">
                  <el-progress :show-text="false" :stroke-width="20" :percentage="100" class="el-bg-inner-running"/>
                  <div style="left: 100%" class="first-right-div-last">
                    <i class="el-icon-caret-top"/>
                    <div>当前申请价:<span>{{businessApplication.price}}</span>小于所有执行价</div>
                  </div>
                </div>
                <div v-else>
                  <el-progress :show-text="false" :stroke-width="20" :percentage="100" class="el-bg-inner-running"/>
                  <div style="color: #4e5dcd" class="first-right-div-last">
                    <i class="el-icon-caret-top"/>
                    <div>当前申请价:<span>{{businessApplication.price}}</span>大于所有执行价</div>
                  </div>
                </div>
              </div>
              <div class="first-right-div">
                <div class="first-right-div-word">最低执行价</div>
                <div style="color: red;font-size: 14px">{{tableParams1.min}}</div>
              </div>
            </div>
          </div>
          <el-table
              :data="tableDate"
              border
              style="width: 100%">
            <el-table-column prop="customerName" align="center" label="客户名称"/>
            <el-table-column prop="approve3Price" align="center" label="执行价"/>
          </el-table>
        </el-tab-pane>
        <el-tab-pane label="同区域客户申请价" name="second">
          <div class="first">
            <div class="first-left">
              <div style="display: flex;flex-direction: row;margin-bottom: 5px">
                <div style="width: 70px;padding: 0 1%;font-size: 12px">特性：</div>
                <div style="width: 80%;padding: 0 1%;font-size: 12px">{{businessApplication.nameValues}}</div>
              </div>
              <div style="display: flex;flex-direction: row;margin: 1% 0">
                <div style="width: 70px;padding: 0 1%;font-size: 12px">申请价格：</div>
                <div style="width: 80%;padding: 0 1%;font-size: 12px">
                  <div v-if="businessApplication.priceApplicationType === 20">
                    <div v-if="businessApplication.floatingPriceType === 20">
                      {{"线缆单价折扣:" + businessApplication.price + "每层加工费:" + businessApplication.floatingPrice}}
                    </div>
                    <div v-else>
                      {{"线缆单价折扣:" + businessApplication.price + "加工费折扣:" + businessApplication.floatingPrice + "%"}}
                    </div>
                  </div>
                  <div v-else>
                    <div v-if="businessApplication.standardFloatingPrice === 0">
                      {{businessApplication.price}}
                    </div>
                    <div v-else>
                      {{businessApplication.price + "/" + businessApplication.floatingPrice}}
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div v-if="show2" class="first-right">
              <div class="first-right-div">
                <div class="first-right-div-word">最高执行价</div>
                <div style="color: #2D8CF0;font-size: 14px">{{tableParams2.max}}</div>
              </div>
              <div class="first-right-div">
                <div v-if="businessApplication.price>=tableParams2.min && businessApplication.price<=tableParams2.max">
                  <el-progress :show-text="false" :stroke-width="20" :percentage="100" class="el-bg-inner-running"/>
                  <div :style="{left: percentage2+'%',color:color2}" class="first-right-div-last">
                    <i class="el-icon-caret-top"/>
                    <div>当前申请价:<span class="number">{{businessApplication.price}}</span></div>
                  </div>
                </div>
                <div v-else-if="businessApplication.price<tableParams2.min">
                  <el-progress :show-text="false" :percentage="100" class="el-bg-inner-running"/>
                  <div style="left: 100%" class="first-right-div-last">
                    <i class="el-icon-caret-top"/>
                    <div>当前申请价:<span>{{businessApplication.price}}</span>小于所有执行价</div>
                  </div>
                </div>
                <div v-else>
                  <el-progress :show-text="false" :stroke-width="20" :percentage="100" class="el-bg-inner-running"/>
                  <div style="color: #4e5dcd" class="first-right-div-last">
                    <i class="el-icon-caret-top"/>
                    <div>当前申请价:<span>{{businessApplication.price}}</span>大于所有执行价</div>
                  </div>
                </div>
              </div>
              <div class="first-right-div">
                <div class="first-right-div-word">最低执行价</div>
                <div style="color: red;font-size: 14px">{{tableParams2.min}}</div>
              </div>
            </div>
          </div>
          <el-table
              :data="tableDate2"
              border
              style="width: 100%;">
            <el-table-column prop="customerName" align="center" label="客户名称"/>
            <el-table-column prop="approve3Price" align="center" label="执行价"/>
          </el-table>
        </el-tab-pane>
      </el-tabs>

      <span slot="footer">
        <el-button type="primary" @click="dialogVisible=false">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
  import constant from "../../../util/constant";

  export default {
    name:"SameCustomerLevelDialog",
    components: {},
    data() {
      return {
        constant,
        show1:false,
        show2:false,
        percentage1:10,
        percentage2:10,
        dialogVisible: false,
        contentLoading: false,
        submitLoading: false,
        activeName: "first",
        color: "#fffe00",
        color2: "#fffe00",
        value: "",
        class1: "",
        class2: "",
        padetailID: "",
        businessApplication: {},
        tableParams1:{
          max:"",
          min:"",
          mean:"",
        },
        tableParams2:{
          max:"",
          min:"",
          mean:"",
        },
        tableDate:[],
        tableDate2:[],
        ruleValidate: {
        },
      };
    },
    methods: {
      open(row) {
        this.dialogVisible = true;
        this.padetailID = parseInt(row.padetailID);
        this.businessApplication = row;
        // this.businessApplication.price = 5200;
        this.getData();
        this.getData2();
      },
      getData() {
        this.$http
          .get("basic", `sd/ba/sameCustomerLevel/${this.padetailID}`)
          .then(resp => {
            this.tableDate = resp;
            let list = [];
            for (let item of this.tableDate) {
              // sum += item.approve3Price;
              list.push(item.approve3Price);
            }
            this.tableParams1.max = Math.max(...list);
            this.tableParams1.min = Math.min(...list);
            if (this.tableParams1.max!=this.tableParams1.min && list.length>=2) {
              this.show1 = true;
            }else {
              this.show1 = false;
            }
            let leg1 = this.tableParams1.max - this.tableParams1.min;
            this.tableParams1.mean = (this.tableParams1.max+this.tableParams1.min);
            console.log(this.businessApplication.price);
            console.log(this.tableParams1.max);
            console.log(this.tableParams1.min);
            if (this.businessApplication.price<=this.tableParams1.max && this.businessApplication.price>=this.tableParams1.min) {
              let leg2 = this.tableParams1.max - this.businessApplication.price;
              // this.percentage1 = (leg2/leg1).toFixed(2)*100;
              this.percentage1 = (leg2/leg1).toFixed(2)*100;
            }else {
              this.percentage1 = 0;
            }
            if (70<=this.percentage1 && this.percentage1<=100) {
              this.color = "#606266";
              console.log("111111");
              this.class1 = "el-bg-inner-running";
            } else if (40<=this.percentage1 && this.percentage1 <70) {
              this.color = "#606266";
              console.log("222222");
              this.class1 = "el-bg-inner-error";
            } else  {
              this.color = "#606266";
              console.log("3333333");
              this.class1 = "el-bg-inner-done";
            }
          });
      },
      getData2() {
        this.$http
          .get("basic", `sd/ba/sameDepartmentLevel/${this.padetailID}`)
          .then(resp => {
            this.tableDate2 = resp;
            let list = [];
            // let sum=0;
            for (let item of this.tableDate2) {
              list.push(item.approve3Price);
              // sum += item.approve3Price;
            }
            this.tableParams2.max = Math.max(...list);
            this.tableParams2.min = Math.min(...list);
            if (this.tableParams2.max!=this.tableParams2.min && list.length>=2) {
              this.show2 = true;
            }else {
              this.show2 = false;
            }
            this.tableParams2.mean = (this.tableParams2.max+this.tableParams2.min);
            let leg1 = this.tableParams2.max - this.tableParams2.min;
            // this.percentage2 = (this.businessApplication.price/this.tableParams2.mean).toFixed(2)*100;
            if (this.businessApplication.price<=this.tableParams2.max && this.businessApplication.price>=this.tableParams2.min) {
              let leg2 = this.tableParams2.max - this.businessApplication.price;
              this.percentage2 = (leg2/leg1).toFixed(2)*100;
            }else {
              this.percentage2 = 0;
            }
            if (70<=this.percentage2 && this.percentage2 <=100) {
              // console.log("111111");
              this.color2 = "#606266";
              this.class2 = "el-bg-inner-running";
            } else if (40<=this.percentage2 && this.percentage2 <70) {
              console.log("222222");
              this.color2 = "#606266";
              this.class2 = "el-bg-inner-error";
            } else  {
              this.color2 = "#606266";
              console.log("3333333");
              this.class2 = "el-bg-inner-done";
            }
          });
      },
    },
  };
</script>

<style lang="scss">
  .SameCustomerLevelPreview{
    .first{
      display: flex;
      flex-direction: row;
      justify-content: space-between;
      align-items: center;
      padding: 20px 10px 30px 10px;
      border: 1px solid #eeeeee;
      border-bottom: none;
      border-top: none;
      .first-left{
        width: 35%;
      }
      .first-right{
        width: 62%;
        display: flex;
        flex-direction: row;
        align-items: center;
        .first-right-div{
          font-size: 12px;
          text-align: center;
          position: relative;
          .first-right-div-word{
            margin-bottom: 5px;
          }
          .first-right-div-last-left{
            position: absolute;
            top: 30px;
            left: -65px;
            color: red;
          }
          .first-right-div-last-right{
            position: absolute;
            top: 30px;
            right: -65px;
            color: red;
          }
          .first-right-div-last{
            position: absolute;
            top: 15px;
            transform: translateX(-50%);
            color: red;
            i{
              display: block;
            }
            div{
              width: 185px;
              position: absolute;
              left: -80px;
              top: 12px;
            }
          }
        }
        .first-right-div:nth-child(2){
          width: 65%;
          margin: 0 2%;
        }
      }
    }
    .el-table__body-wrapper{
      height: 260px;
      overflow-y: scroll;
    }
    .el-dialog .el-dialog__body{
      padding-top: 15px;
    }
    .el-dialog .el-dialog__header .el-dialog__title{
      font-size: 14px;
    }
    .el-progress{
      width:100%;
    }
    .el-progress__text{
      color: #fff;
      font-size: 14px;
    }
    .el-progress-bar__outer{
      height: 12px!important;
      /*border: 1px solid #78335f;*/
      background-color: #f5f5f5;
    }

    /* 渐变进度条 */
    .el-bg-inner-running .el-progress-bar__inner{
      background-color: unset;
      background-image:linear-gradient(to right, #4e5dcd,#6778b1,#fffe00,#ff0000)!important;
    }
    .el-bg-inner-error .el-progress-bar__inner{
      background-color: unset;
      background-image:linear-gradient(to right, #4e5dcd,#6778b1,#fffe00)!important;
    }
    .el-bg-inner-done .el-progress-bar__inner{
      background-image:linear-gradient(to right, #4e5dcd,#6778b1)!important;
    }
    .el-tabs__header{
      margin-bottom: 0!important;
    }
    /*.el-table th{*/
    /*  background: #cbe8fd;*/
    /*}*/
  }

</style>
